import { clearCurrentAtlasAuthInfo } from "@/modules/atlas-auth/clear-info";
import { getCurrentAtlasAuthInfo } from "@/modules/atlas-auth/get-info";
import { setCurrentAtlasAuthInfo } from "@/modules/atlas-auth/set-info";
import { moduleFactory } from "@/factories/module";

export const atlasAuthModule = moduleFactory.create({
  setCurrentAuthInfo: setCurrentAtlasAuthInfo,
  getCurrentAuthInfo: getCurrentAtlasAuthInfo,
  clearCurrentAuthInfo: clearCurrentAtlasAuthInfo,
});
